import React from 'react';

export default function Table({ columns, data, onRowClick }) {
  return (
    <div className="hhms-table-wrap" style={{
      overflowX: 'auto',
      background: '#fff',
      borderRadius: 16,
      border: '1px solid #ECE3E7',
      boxShadow: '0 1px 2px rgba(13,27,46,.04), 0 10px 30px -16px rgba(13,27,46,.10)',
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', fontSize: 13 }}>
        <thead>
          <tr>
            {columns.map((col, ci) => (
              <th key={col.key} style={{
                padding: ci === 0 ? '12px 16px 12px 20px'
                       : ci === columns.length - 1 ? '12px 20px 12px 16px'
                       : '12px 16px',
                textAlign: 'left', fontWeight: 600,
                color: '#8b7681', fontSize: 11, textTransform: 'uppercase',
                background: 'transparent',
                borderBottom: '1px solid #ECE3E7', letterSpacing: '0.06em',
              }}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.length === 0 && (
            <tr><td colSpan={columns.length} style={{ padding: 32, textAlign: 'center', color: '#a99aa0' }}>No records found</td></tr>
          )}
          {data?.map((row, i) => (
            <tr key={i}
              className="hhms-table-row"
              onClick={() => onRowClick?.(row)}
              style={{
                borderBottom: '1px solid #F0F4F9',
                cursor: onRowClick ? 'pointer' : 'default',
                transition: 'background 0.1s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#f7f3f4'}
              onMouseLeave={e => e.currentTarget.style.background = ''}
            >
              {columns.map((col, ci) => (
                <td key={col.key} style={{
                  padding: ci === 0 ? '12px 16px 12px 20px'
                         : ci === columns.length - 1 ? '12px 20px 12px 16px'
                         : '12px 16px',
                  color: '#334155', fontSize: 13,
                }}>
                  {col.render ? col.render(row[col.key], row) : row[col.key] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
